import { useTranslation } from 'next-i18next'

import { useRouter } from 'next/router'

import ROUTES from '~/shared/constants/routes.const'
import { ButtonPrimary } from '~/components/Buttons'
import { TREASURE_TRAIL_STAGES_NO } from '~/statistics/constants'
import { TreasureTrailProductAPIStat } from '~/statistics/types/stack-n-load.types'
import SVGImage from '~/components/Image/SVGImage'
import ResponsiveImage from '~/components/Image/ResponsiveImage'

interface Props {
  product: TreasureTrailProductAPIStat
}

const mediaQuery = [{ screen: '(min-width: 280px)', width: '108px' }]

export default function TreasureTrailDetails({ product }: Props): React.ReactElement {
  const { t } = useTranslation('statistics')
  const router = useRouter()
  const isFamilyView = router.asPath.includes(ROUTES.FAMILY_ADMIN_PANEL)

  const { summary, details } = product

  return (
    <div className="mt-3">
      <div className="w-full flex flex-col items-center justify-center grow font-semibold rounded overflow-hidden shadow-card space-y-3 py-2">
        <p>
          <span className="text-purple">{t('stage_reached')}</span>
        </p>
        <ResponsiveImage
          alt={t('stage_reached')}
          height={83}
          imageWidths="108"
          mediaQuery={mediaQuery}
          srcKey="scoreboard/stage-reached.png"
          width={108}
        />
        <p>{summary.stageReached || 0}</p>
      </div>
      <div className="relative">
        <div className="mt-3 mb-2">
          {[...Array(TREASURE_TRAIL_STAGES_NO)].map((_, index) => {
            const stageId = index + 1

            return (
              <div
                className="w-full flex flex-col items-center justify-center grow font-semibold rounded overflow-hidden shadow-card py-2 my-3"
                key={stageId}
              >
                <p className="text-purple">
                  {t('stage')} {stageId}
                </p>
                <SVGImage alt={t('stage')} className="w-28 py-1" srcKey="scoreboard/stage-line.svg" />
                <p className="pt-1">Levels completed {details[String(stageId)]?.completedLevels || 0}</p>
              </div>
            )
          })}
        </div>
        {!isFamilyView && (
          <ButtonPrimary className="ml-auto mt-5 py-0.5 px-7" href={ROUTES.TREASURETRAIL} noPadding size="medium">
            {t('play')}
          </ButtonPrimary>
        )}
      </div>
    </div>
  )
}
